import { render, staticRenderFns } from "./TaxonomyNodesTree.vue?vue&type=template&id=0a272e41&scoped=true&"
import script from "./TaxonomyNodesTree.vue?vue&type=script&lang=js&"
export * from "./TaxonomyNodesTree.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyNodesTree.vue?vue&type=style&index=0&id=0a272e41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a272e41",
  null
  
)

export default component.exports